import { makeStyles } from '@material-ui/core';
import { XMEI_PRIMARY_COLOR, XMEI_SECONDARY_COLOR } from 'src/consts/common';

export const useStyles = makeStyles({
  card: {
    marginBottom: 20,
    paddingHorizontal: 10,
    width: '100%',
    paddingBottom: 10,
  },
  next: {
    backgroundColor: XMEI_SECONDARY_COLOR,
    color: '#FFF',
    fontWeight: 'bold',
    height: '40px',
    '&:hover': {
      backgroundColor: XMEI_PRIMARY_COLOR,
    },
  },
});
